import { Navigate } from "react-router-dom";
import jwt from "jwt-decode";

export default function ConfigRedirection() {
  const token = localStorage.getItem("@medusapayments:access_token");
  const url_local = window.location.pathname;

  //URLS
  let url_dashboard = "/dashboard";
  let url_precadastro = "/complet-registration";
  let url_analisandodocumento = "/analyzing";

  //STATUS TOKENS
  let statustoken_pre_cadastro = "Pre-registration";
  let statustoken_analisando_documento = "Account-analysis";

  if (token) {
    const unscrypted = jwt(token);

    /**
     * @PreCadastro
     * Verifica se o status do token é "Pre-registration"
     */

    const isValid_PreCadastro =
      unscrypted.statustoken === statustoken_pre_cadastro;

    if (isValid_PreCadastro) {
      if (url_local !== url_precadastro) {
        return <Navigate to={url_precadastro} replace />;
      }
    }

    // Caso acesse o pre cadastro sem ter permissao redireciona para dashboard

    if (!isValid_PreCadastro) {
      if (url_local === url_precadastro) {
        return <Navigate to={url_dashboard} replace />;
      }
    }

    /**
     * @AccountAnalysis
     * Verifica se o status do token é "Account-analysis"
     */

    const isValid_AnalisandoDoc =
      unscrypted.statustoken === statustoken_analisando_documento;

    if (isValid_AnalisandoDoc) {
      if (url_local !== url_analisandodocumento) {
        return <Navigate to={url_analisandodocumento} replace />;
      }
    }

    // Caso acesse o analisando documento sem ter permissao redireciona para dashboard

    if (!isValid_AnalisandoDoc) {
      if (url_local === url_analisandodocumento) {
        return <Navigate to={url_dashboard} replace />;
      }
    }
  }

  // Retorna null ou outro componente, se não houver redirecionamento
  return null;
}
